var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWork6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "560px",
    height: "454px",
    viewBox: "0 0 560 454",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Agency-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Agency-1",
    transform: "translate(-172.000000, -1602.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 6,
    transform: "translate(172.000000, 1602.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 560,
    height: 454
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_online_test_gba7",
    transform: "translate(39.000000, 116.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3301653,212.380952 L42.6864844,212.137958 C42.5450358,212.084279 28.4671993,206.652358 21.8725238,194.33572 C15.2775842,182.018493 18.5068137,167.188509 18.5401973,167.040456 L18.6921862,166.365079 L19.3355725,166.608074 C19.4770211,166.661753 33.554563,172.093674 40.1495331,184.410312 C46.7444727,196.727538 43.5152483,211.557523 43.4818596,211.705576 L43.3301653,212.380952 Z M22.9285472,193.76237 C28.5041031,204.176151 39.6288463,209.514287 42.4475163,210.732917 C42.9834218,207.690477 44.6640926,195.3874 39.0935198,184.983646 C33.5235313,174.581064 22.3943942,169.234671 19.5745508,168.013094 C19.0383456,171.05731 17.3582691,183.359199 22.9285472,193.76237 Z",
    id: "Shape",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2621879,189.017496 C38.0063586,196.094473 42.5294118,210.151299 42.5294118,210.151299 C42.5294118,210.151299 28.0113997,212.734081 16.2672239,205.657109 C4.52304813,198.580137 0,184.523306 0,184.523306 C0,184.523306 14.5180171,181.940518 26.2621879,189.017496 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.191077,2.75042955 L275.919974,2.75042955 L275.919974,0 L215.48968,0 L215.48968,2.75042955 L81.6691962,2.75042955 C79.2783258,2.75042955 76.9853793,3.70144322 75.2947792,5.39425826 C73.604179,7.08707329 72.6544118,9.383023 72.6544118,11.7770243 L72.6544118,194.505121 C72.6544118,199.490376 76.6904601,203.531746 81.6691962,203.531746 L409.191077,203.531746 C411.581955,203.531746 413.874907,202.580727 415.565511,200.887906 C417.256115,199.195085 418.205882,196.899129 418.205882,194.505121 L418.205882,11.7770243 C418.205882,9.38301903 417.256114,7.08706542 415.565509,5.3942495 C413.874904,3.70143358 411.581952,2.75042275 409.191077,2.75042955 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFD15C",
    x: 85.0588235,
    y: 19.468254,
    width: 320.742647,
    height: 180.52381
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF4C60",
    cx: 244.544118,
    cy: 10.6190476,
    rx: 3.54411765,
    ry: 3.53968254
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.080882,42.4761905 L372.132353,42.4761905 L372.132353,26.547619 L388.080882,26.547619 L388.080882,42.4761905 Z M372.825792,41.783666 L387.38747,41.783666 L387.38747,27.2401649 L372.825792,27.2401649 L372.825792,41.783666 Z",
    id: "Shape",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.940497,197.319626 L395.56291,197.319626 L395.56291,195.118891 C395.562912,195.003162 395.515686,194.892172 395.431622,194.810339 C395.347557,194.728507 395.23354,194.68254 395.114656,194.68254 L384.356624,194.68254 C384.23774,194.68254 384.123724,194.728509 384.039661,194.810341 C383.955597,194.892174 383.908372,195.003163 383.908375,195.118891 L383.908375,197.319626 L377.184604,197.319626 L377.184604,195.118891 C377.184607,195.003163 377.137381,194.892174 377.053318,194.810341 C376.969254,194.728509 376.855239,194.68254 376.736355,194.68254 L365.978323,194.68254 C365.859438,194.68254 365.745421,194.728507 365.661357,194.810339 C365.577292,194.892172 365.530066,195.003162 365.530069,195.118891 L365.530069,197.319626 L358.806303,197.319626 L358.806303,195.118891 C358.806306,195.003162 358.75908,194.892172 358.675015,194.810339 C358.590951,194.728507 358.476934,194.68254 358.358049,194.68254 L347.599992,194.68254 C347.481108,194.68254 347.367092,194.728509 347.283029,194.810341 C347.198965,194.892174 347.15174,195.003163 347.151743,195.118891 L347.151743,197.319626 L340.427998,197.319626 L340.427998,195.118891 C340.428,195.003163 340.380775,194.892174 340.296711,194.810341 C340.212648,194.728509 340.098632,194.68254 339.979749,194.68254 L329.221717,194.68254 C329.102833,194.68254 328.988817,194.728509 328.904754,194.810341 C328.82069,194.892174 328.773465,195.003163 328.773468,195.118891 L328.773468,197.319626 L322.049697,197.319626 L322.049697,195.118891 C322.0497,195.003162 322.002474,194.892172 321.918409,194.810339 C321.834344,194.728507 321.720328,194.68254 321.601443,194.68254 L310.843416,194.68254 C310.724531,194.68254 310.610514,194.728507 310.52645,194.810339 C310.442385,194.892172 310.395159,195.003162 310.395162,195.118891 L310.395162,197.319626 L303.671386,197.319626 L303.671386,195.118891 C303.67139,195.003162 303.624165,194.892172 303.540102,194.81034 C303.456038,194.728507 303.342021,194.68254 303.223137,194.68254 L292.46511,194.68254 C292.346226,194.68254 292.232211,194.728509 292.148147,194.810341 C292.064084,194.892174 292.016859,195.003163 292.016861,195.118891 L292.016861,197.319626 L285.293091,197.319626 L285.293091,195.118891 C285.293093,195.003163 285.245868,194.892174 285.161805,194.810341 C285.077741,194.728509 284.963725,194.68254 284.844842,194.68254 L200.573607,194.68254 C200.454723,194.68254 200.340708,194.728509 200.256644,194.810341 C200.172581,194.892174 200.125356,195.003163 200.125358,195.118891 L200.125358,197.319626 L193.401577,197.319626 L193.401577,195.118891 C193.40158,195.003163 193.354355,194.892174 193.270291,194.810341 C193.186228,194.728509 193.072212,194.68254 192.953328,194.68254 L182.195296,194.68254 C182.076412,194.68254 181.962395,194.728507 181.87833,194.810339 C181.794265,194.892172 181.74704,195.003162 181.747042,195.118891 L181.747042,197.319626 L175.023277,197.319626 L175.023277,195.118891 C175.023279,195.003162 174.976054,194.892172 174.891989,194.810339 C174.807924,194.728507 174.693907,194.68254 174.575023,194.68254 L163.816991,194.68254 C163.698107,194.68254 163.584091,194.728509 163.500028,194.810341 C163.415964,194.892174 163.368739,195.003163 163.368742,195.118891 L163.368742,197.319626 L156.644971,197.319626 L156.644971,195.118891 C156.644974,195.003163 156.597748,194.892174 156.513685,194.810341 C156.429621,194.728509 156.315606,194.68254 156.196722,194.68254 L145.43869,194.68254 C145.319805,194.68254 145.205788,194.728507 145.121724,194.810339 C145.037659,194.892172 144.990433,195.003162 144.990436,195.118891 L144.990436,197.319626 L138.26667,197.319626 L138.26667,195.118891 C138.266673,195.003162 138.219447,194.892172 138.135382,194.810339 C138.051318,194.728507 137.937301,194.68254 137.818416,194.68254 L127.060384,194.68254 C126.9415,194.68254 126.827485,194.728509 126.743421,194.810341 C126.659358,194.892174 126.612133,195.003163 126.612135,195.118891 L126.612135,197.319626 L119.888365,197.319626 L119.888365,195.118891 C119.888367,195.003163 119.841142,194.892174 119.757079,194.810341 C119.673015,194.728509 119.559,194.68254 119.440116,194.68254 L108.682084,194.68254 C108.5632,194.68254 108.449184,194.728509 108.365121,194.810341 C108.281057,194.892174 108.233832,195.003163 108.233835,195.118891 L108.233835,197.319626 L101.510064,197.319626 L101.510064,195.118891 C101.510067,195.003162 101.462841,194.892172 101.378776,194.810339 C101.294711,194.728507 101.180695,194.68254 101.06181,194.68254 L90.3037831,194.68254 C90.1848983,194.68254 90.0708815,194.728507 89.9868169,194.810339 C89.9027522,194.892172 89.8555262,195.003162 89.855529,195.118891 L89.855529,197.319626 L69.2359732,197.319626 C63.2944782,197.319626 58.4779412,202.008318 58.4779412,207.792115 L58.4779412,212.527531 C58.4779412,218.31132 63.2944862,223 69.2359732,223 L426.940497,223 C432.881983,223 437.698529,218.311319 437.698529,212.527531 L437.698529,207.792115 C437.698529,202.00832 432.881991,197.319629 426.940497,197.319626 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 14.1764706,
    y: 212.380952,
    width: 467.823529,
    height: 1.76984127
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.308824,118.579365 L283.529412,118.579365 L283.529412,60.1746032 L386.308824,60.1746032 L386.308824,118.579365 Z M284.54703,117.56363 L385.291206,117.56363 L385.291206,61.1903382 L284.54703,61.1903382 L284.54703,117.56363 Z",
    id: "Shape",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.698529,130.968254 L104.551471,130.968254 L104.551471,74.3333333 L196.698529,74.3333333 L196.698529,130.968254 Z M105.575327,129.956916 L195.674673,129.956916 L195.674673,75.3446712 L105.575327,75.3446712 L105.575327,129.956916 Z",
    id: "Shape",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.652714,109.846978 L147.56106,108.722854 C147.28687,106.388702 148.109956,103.838078 150.39639,101.244743 C152.454354,98.953297 153.597568,97.2676072 153.597568,95.322236 C153.597568,93.117681 152.134199,91.647976 149.253154,91.6047771 C147.605411,91.598443 145.994569,92.06581 144.634311,92.9448801 L143.536765,90.2214449 C145.046094,89.1837195 147.652687,88.4920635 150.076235,88.4920635 C155.335387,88.4920635 157.713235,91.5615529 157.713235,94.8465446 C157.713235,97.7864422 155.975416,99.9046043 153.780359,102.368348 C151.768355,104.616102 151.036668,106.518274 151.17376,108.722829 L151.219459,109.846978 L147.652714,109.846978 Z M146.646582,115.899056 C146.596834,115.186037 146.865153,114.485895 147.386464,113.968433 C147.907774,113.450972 148.634457,113.163457 149.390273,113.175621 C150.990995,113.175621 152.088526,114.299251 152.088526,115.899056 C152.129698,116.843265 151.620276,117.732892 150.761451,118.216591 C149.902627,118.70029 148.832481,118.70029 147.973656,118.216591 C147.114831,117.732892 146.60541,116.843265 146.646582,115.899056 L146.646582,115.899056 Z",
    id: "Shape",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.174773,95.6882475 L330.083119,94.5641242 C329.808929,92.2299723 330.632015,89.679348 332.918448,87.0860124 C334.976412,84.7945668 336.119627,83.108877 336.119627,81.1635058 C336.119627,78.9589509 334.656257,77.4892459 331.775213,77.4460469 C330.12747,77.4397129 328.516627,77.9070799 327.15637,78.7861499 L326.058824,76.0627147 C327.568152,75.0249894 330.174746,74.3333333 332.598293,74.3333333 C337.857446,74.3333333 340.235294,77.4028228 340.235294,80.6878145 C340.235294,83.6277121 338.497474,85.7458741 336.302418,88.2096179 C334.290414,90.4573718 333.558727,92.3595441 333.695819,94.5640991 L333.741518,95.6882475 L330.174773,95.6882475 Z M329.16864,101.740326 C329.118893,101.027307 329.387212,100.327165 329.908522,99.8097031 C330.429833,99.2922414 331.156516,99.0047273 331.912332,99.0168905 C333.513054,99.0168905 334.610585,100.140521 334.610585,101.740326 C334.651757,102.684535 334.142335,103.574162 333.28351,104.057861 C332.424685,104.54156 331.35454,104.54156 330.495715,104.057861 C329.63689,103.574162 329.127469,102.684535 329.16864,101.740326 L329.16864,101.740326 Z",
    id: "Shape",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    cx: 246.316176,
    cy: 132.738095,
    rx: 44.3014706,
    ry: 44.2460317
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F2E41",
    points: "229.572262 194.68254 216.191176 192.282094 220.531198 164.595238 233.911765 166.995684"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#2F2E41",
    transform: "translate(251.869095, 181.707892) rotate(10.261060) translate(-251.869095, -181.707892) ",
    points: "245.16314 169.696598 258.576775 169.695636 258.575051 193.719185 245.161416 193.720148"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    transform: "translate(254.193282, 193.798324) rotate(-78.586970) translate(-254.193282, -193.798324) ",
    cx: 254.193282,
    cy: 193.798324,
    rx: 4.19016566,
    ry: 11.1779944
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    transform: "translate(226.577276, 193.829532) rotate(-82.453700) translate(-226.577276, -193.829532) ",
    cx: 226.577276,
    cy: 193.829532,
    rx: 4.19012798,
    ry: 11.1780947
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 250.746324,
    cy: 123.003968,
    rx: 15.0625,
    ry: 15.0436508
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 256.948529,
    cy: 116.809524,
    rx: 5.31617647,
    ry: 5.30952381
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.66966,86.0400672 C212.003839,69.5775532 226.130858,55.6336902 244.223243,54.8955826 C262.315628,54.1574749 277.522165,66.9046228 278.188002,83.3671419 C278.853839,99.8296611 266.277314,103.570082 248.184929,104.308189 C230.092545,105.046297 213.335487,102.502586 212.66966,86.0400672 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    transform: "translate(287.753010, 125.374957) rotate(-12.910100) translate(-287.753010, -125.374957) ",
    cx: 287.75301,
    cy: 125.374957,
    rx: 22.0764436,
    ry: 6.92792328
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    transform: "translate(201.080799, 139.782516) rotate(-12.910100) translate(-201.080799, -139.782516) ",
    cx: 201.080799,
    cy: 139.782516,
    rx: 22.0764436,
    ry: 6.92792328
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.840045,150.55665 C235.21928,154.217564 236.475077,157.95395 239.134388,160.358347 C241.793698,162.762744 245.452511,163.469867 248.732587,162.21335 C252.012663,160.956832 254.41568,157.927569 255.036444,154.266654 C255.996062,148.607373 251.897552,146.604778 246.596615,145.580285 C241.295678,144.555791 236.799668,144.897368 235.840045,150.55665 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0CDE1",
    x: 79.7426471,
    y: 7.07936508,
    width: 72.6544118,
    height: 69.0238095
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 86.8308824,
    y: 15.9285714,
    width: 56.7058824,
    height: 42.4761905
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 86.8308824,
    y: 61.9444444,
    width: 30.125,
    height: 1.76984127
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 86.8308824,
    y: 67.2539683,
    width: 30.125,
    height: 1.76984127
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 96.5772059,
    cy: 36.281746,
    rx: 6.20220588,
    ry: 6.19444444
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF4C60",
    cx: 116.069853,
    cy: 36.281746,
    rx: 6.20220588,
    ry: 6.19444444
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 133.790441,
    cy: 36.281746,
    rx: 6.20220588,
    ry: 6.19444444
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 115.183824,
    cy: 10.6190476,
    rx: 3.54411765,
    ry: 3.53968254
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0CDE1",
    x: 113.411765,
    y: 139.81746,
    width: 72.6544118,
    height: 69.0238095
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 122.272059,
    y: 148.666667,
    width: 56.7058824,
    height: 42.4761905
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF4C60",
    x: 134.676471,
    y: 155.746032,
    width: 19.4926471,
    height: 19.468254
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.764706,161.055556 L141.764706,184.063492 L164.801471,184.063492 L164.801471,161.055556 L141.764706,161.055556 Z M163.802244,183.06549 L142.763928,183.06549 L142.763928,162.053557 L163.802244,162.053557 L163.802244,183.06549 Z",
    id: "Shape",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 122.272059,
    y: 196.452381,
    width: 30.125,
    height: 1.76984127
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 150.625,
    cy: 145.126984,
    rx: 3.54411765,
    ry: 3.53968254
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0CDE1",
    x: 303.022059,
    y: 120.349206,
    width: 72.6544118,
    height: 69.0238095
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 310.110294,
    y: 127.428571,
    width: 56.7058824,
    height: 42.4761905
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 333.147059,
    y: 161.055556,
    width: 12.4044118,
    height: 3.53968254
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 318.970588,
    y: 132.738095,
    width: 40.7573529,
    height: 1.76984127
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 318.970588,
    y: 138.047619,
    width: 40.7573529,
    height: 1.76984127
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 318.970588,
    y: 143.357143,
    width: 40.7573529,
    height: 1.76984127
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 318.970588,
    y: 148.666667,
    width: 40.7573529,
    height: 1.76984127
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 318.970588,
    y: 152.206349,
    width: 40.7573529,
    height: 1.76984127
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 311.882353,
    y: 175.214286,
    width: 30.125,
    height: 1.76984127
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 310.110294,
    y: 178.753968,
    width: 42.5294118,
    height: 1.76984127
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 338.463235,
    cy: 123.888889,
    rx: 3.54411765,
    ry: 3.53968254
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork6);
export default __webpack_public_path__ + "static/media/work-6.193ff0f36ce61bd0a410efff5f3110e1.svg";
export { ForwardRef as ReactComponent };